import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../commons/layout/layout";
import { useTranslation } from "react-i18next";
import { Breadcrumb, BreadCrumbItem } from "../commons/breadcrumb/breadcrumb";
import { Content } from "../commons/content/content";

export const Page403 = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const title = t("general.403");

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{t("general.403")}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content md={12}>{t("general.403.description")}</Content>
      </LayoutContent>
    </Layout>
  );
};
